<template>
    <div v-if="skips" class="skips__container">
        <ul :class="{expanded: isExpanded}">
            <li v-for="(a, b) in skips">
                <b>{{ b }}</b> &mdash; {{ a }}
            </li>
        </ul>
        <a v-if="getCounts > 2" class="anchor" @click.prevent="onToggle">{{ getLinkTitle }}</a>
    </div>
    <div v-if="domainErrors" class="skips__container">
        <ul :class="{expanded: isExpandedDomainErrors}">
            <li v-for="error in domainErrors" v-html="error"></li>
        </ul>
        <a v-if="getCountsDomainErrors > 2" class="anchor" @click.prevent="onToggleDomainErrors">{{ getLinkTitleDomainErrors }}</a>
    </div>
</template>

<script>
export default {
    name: "CompareDashSkips",
    data() {
        return {
            isExpanded: false,
            isExpandedDomainErrors: false,
        };
    },
    props: {
        skips: {
            type: Object,
            required: false,
            default: null,
        },
        domainErrors: {
            type: Array,
            required: false,
            default: null,
        }
    },
    computed: {
        getLinkTitle() {
            return this.isExpanded ? this.$t("lang.main.btn.hide") : this.$t("lang.main.btn.more") + ' (' + this.getCounts + ')';
        },
        getLinkTitleDomainErrors() {
            return this.isExpandedDomainErrors ? this.$t("lang.main.btn.hide") : this.$t("lang.main.btn.more") + ' (' + this.getCountsDomainErrors + ')';
        },
        getCounts() {
            return Object.keys(this.skips).length;
        },
        getCountsDomainErrors() {
            return Object.keys(this.domainErrors).length;
        }
    },
    methods: {
        onToggle() {
            this.isExpanded = !this.isExpanded;
        },
        onToggleDomainErrors() {
            this.isExpandedDomainErrors = !this.isExpandedDomainErrors;
        }
    }
}
</script>

<style scoped>
.skips__container {
    text-align: left;
    font-size: 14px;
    line-height: 22px;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
    width: auto;
}
.skips__container ul {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.skips__container li {
    color: red;
}
.skips__container .expanded {
    -webkit-line-clamp: unset;
}
.skips__container .anchor {
    display: block;
    padding: 8px 0;
    text-decoration: underline;
    text-align: left;
    cursor: pointer;
}
</style>
